<div class="content">
    <ng-content></ng-content>
</div>

@if (image) {
<figure class="asset asset--image asset--side-image">
    <img class="image--side" [src]="image" [alt]="image" />
</figure>
}
